import React, { useState } from 'react';
import axios from 'axios';
import { CircularProgress, Typography } from '@mui/material';

interface FileUploadI {
  token?: string;
  uploadUrl: string;
  successMessage?: string;
  errorMessage?: string;
  onSuccess?: any;
  onError?: any;
}

const FileUpload = (props: FileUploadI) => {
  const { uploadUrl, successMessage, errorMessage, onSuccess, onError, token } =
    props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleFileUpload = (event: any) => {
    // get the selected file from the input
    const file = event.target.files[0];
    // create a new FormData object and append the file to it
    const formData = new FormData();
    formData.append('file', file);
    // make a POST request to the File Upload API with the FormData object and Rapid API headers
    setLoading(true);
    setSuccess('');
    setError('');
    axios
      .post(uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLoading(false);
        setSuccess(successMessage || 'Upload successful');

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setError(errorMessage || 'Failed to upload');
        if (onError) {
          onError(error);
        }
      });
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color={'danger'}>{error}</Typography>;
  }

  return (
    <div>
      <input type='file' onChange={handleFileUpload} />
      {success && <Typography color={'success'}>{success}</Typography>}
    </div>
  );
};

export { FileUpload };
